import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {

        document.addEventListener("DOMContentLoaded", function() {

            // tabs videos
            var navLinks = document.querySelectorAll('#videoTabsNav .nav-link');
            var tabPanes = document.querySelectorAll('#videoTabsContent .tab-pane');

            navLinks.forEach(function(navLink) {
                navLink.addEventListener('click', function(event) {
                    event.preventDefault();

                    navLinks.forEach(function(link) {
                        link.classList.remove('active');
                    });
                    tabPanes.forEach(function(pane) {
                        pane.classList.remove('show', 'active');
                    });

                    var target = this.getAttribute('href');
                    this.classList.add('active');
                    document.querySelector(target).classList.add('show', 'active');
                });
            });

            // tabs atty
            var navLinksAtty = document.querySelectorAll('#attyTabsNav .nav-link');
            var tabPanesAtty = document.querySelectorAll('#attyTabsContent .tab-pane');

            navLinksAtty.forEach(function(navLinkAtty) {
                navLinkAtty.addEventListener('click', function(event) {
                    event.preventDefault();

                    navLinksAtty.forEach(function(linkAtty) {
                        linkAtty.classList.remove('active');
                    });
                    tabPanesAtty.forEach(function(paneAtty) {
                        paneAtty.classList.remove('show', 'active');
                    });

                    var target = this.getAttribute('href');
                    this.classList.add('active');
                    document.querySelector(target).classList.add('show', 'active');
                });
            });

            // tabs bio
            var navLinksBio = document.querySelectorAll('#bioTabsNav .nav-link');
            var tabPanesBio = document.querySelectorAll('#bioTabsContent .tab-pane');

            navLinksBio.forEach(function(navLinkBio) {
                navLinkBio.addEventListener('click', function(event) {
                    event.preventDefault();

                    navLinksBio.forEach(function(linkBio) {
                        linkBio.classList.remove('active');
                    });
                    tabPanesBio.forEach(function(paneBio) {
                        paneBio.classList.remove('show', 'active');
                    });

                    var target = this.getAttribute('href');
                    this.classList.add('active');
                    document.querySelector(target).classList.add('show', 'active');
                });
            });

            const buttons = document.querySelectorAll('.show-answer-btn');

            buttons.forEach(function(button) {
                button.addEventListener('click', function(event) {
                    event.preventDefault();
                    const answerDiv = this.nextElementSibling;
                    answerDiv.style.display = 'block';
                    this.style.display = 'none';
                });
            });

            // Hamburger Menu Display and Animation
            const toggleButton = document.querySelector(".hamburger");
            const menuContainer = document.querySelector(".mega-menu-container");
            const headerMegaMenu = document.querySelector(".header-mega-menu-container");
            const menuHeaderIconOpen = document.getElementById("menuHeaderIconOpen");
            const menuHeaderIconClose = document.getElementById("menuHeaderIconClose");

            if (toggleButton && menuContainer) {
                toggleButton.addEventListener("click", function() {
                    menuContainer.classList.toggle("open");
                    headerMegaMenu.classList.toggle("bordered");

                    if (menuHeaderIconOpen.style.display !== 'none') {
                        menuHeaderIconOpen.style.display = 'none';
                        menuHeaderIconClose.style.display = 'block';
                        menuHeaderIconClose.classList.add("spinning");

                        setTimeout(() => {
                            menuHeaderIconClose.classList.remove("spinning");
                        }, 500);
                    } else {
                        menuHeaderIconOpen.style.display = 'block';
                        menuHeaderIconClose.style.display = 'none';
                        menuHeaderIconOpen.classList.add("spinning");

                        setTimeout(() => {
                            menuHeaderIconOpen.classList.remove("spinning");
                        }, 500);
                    }
                });
            }

            // Tab text replacement
            function replaceText() {
                if (window.innerWidth < 768) {
                    var navItem = document.querySelector('#attyTabsNav .nav-link#nav-atty-item-4');
                    if (navItem && navItem.textContent.includes('Support Staff')) {
                        navItem.textContent = navItem.textContent.replace('Support Staff', 'Staff');
                    }
                }
            }

            // Run the function on load
            replaceText();

            // Run the function on window resize
            window.addEventListener('resize', replaceText);
        });

    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${locationID.value}/`;
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">${phone}</a>` :
                    '';
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Direction</a>
                   <button class="btn cw-modal" data-cw-target="#hoursModal" id="office-hours">Office Hours</button>
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /></a></figure>` :
                    '';

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}<br>
                   ${address2HTML}<br>
                   <span>${city}, ${state} ${zip}</span><br>
               </address>
               ${phoneHTML}<br>
               ${emailHTML}${officeInfoButtons}
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },
};

export default CwThemeFramework;